
import { Context } from '@nuxt/types'
import MachinationsLightPage from '~/domain/pages/MachinationsLightPage'

export default MachinationsLightPage.extend({
  name: 'partners',
  layout: 'machinations',
  head() {
    // @ts-ignore
    const pageHead = this.pageHead()
    return {
      ...pageHead,
      title: this.$t("wordCapitalPartners"),
    }
  },
  async asyncData(context: Context): Promise<void> {
    const { store } = context

    await store.dispatch('common/setupPageLight', { context })
    await store.dispatch('wp/fetchPageBySlug', { context, slug: 'partners' })

    store.commit('common/updateIsHomepage', true)
    store.commit('common/isBusy', false)
  },
})
